export default {
  HOME: '/',
  LIVE_TV: '/player/channel',
  CONTINUE_WATCHING: '/continue-watching',
  MY_WATCHLIST: '/watchlist',
  PURCHASES: '/purchases',
  SPORT: '/sport',
  MOVIES: '/movies',
  VOD: '/vod',
  TV_SERIES: '/tv_series',
  KIDS: '/kids',
  PROFILE: '/profile',
};
